import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ScheduleListModule } from '@fi-shared/checklist/schedule/schedule-list/schedule-list.module';
import { FiChecklist2ScheduleEditModule } from '@fi-shared/checklist/schedule/schedule-edit/schedule-edit.module';
import { FiChecklist2ScheduleService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule.service';
import { FiChecklist2ScheduleTimeIntervalHelperService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-time-interval-helper.service';
import { FiChecklist2ScheduleIntervalService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-interval.service';
import { FiChecklist2ScheduleFormatService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-format.service';
import { FiChecklist2ScheduleFactoryService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-factory.service';
import { FiChecklist2ScheduleDialogService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-dialog.service';
import { FiChecklist2ScheduleSharingDisplayService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-sharing-display.service';

@NgModule({
    imports: [CommonModule, FiChecklist2ScheduleListModule, FiChecklist2ScheduleEditModule],
    declarations: [],
    providers: [
        FiChecklist2ScheduleService,
        FiChecklist2ScheduleTimeIntervalHelperService,
        FiChecklist2ScheduleIntervalService,
        FiChecklist2ScheduleFormatService,
        FiChecklist2ScheduleFactoryService,
        FiChecklist2ScheduleDialogService,
        FiChecklist2ScheduleSharingDisplayService,
    ],
})
export class FiChecklist2ScheduleModule {}
